import { Component } from '@angular/core';
import { ILotDocumentDto } from '@classictechsolutions/hubapi-transpiled-enums';

@Component({
    selector: 'app-house-and-land',
    templateUrl: './house-and-land.component.html',
    styleUrls: ['./house-and-land.component.scss'],
    standalone: false
})
export class HouseAndLandComponent {

    public lots: ILotDocumentDto[] = [];
    public lotsLoaded = false;
    public noMoreResults = false;
    public defaultCardSize = '25%';

    constructor() { }

    public getFilterredLots($event): void {
        this.lots = $event.lots;
        this.noMoreResults = $event.noMoreResults;
        this.lotsLoaded = true;
    }

    public setResultSize(size: string): void {
        this.defaultCardSize = size + '%';
    }

}
